export const EU_COUNTRIES = ['BE', 'EL', 'LT', 'PT', 'BG', 'ES', 'LU', 'RO', 'CZ', 'FR', 'HU', 'SI', 'DK', 'HR', 'MT', 'SK', 'DE', 'IT', 'NL', 'FI', 'EE', 'CY', 'AT', 'SE', 'IE', 'LV', 'PL'];

export const isNL = (countryCode: string) => countryCode === 'NL';
export const isEU = (countryCode: string) => EU_COUNTRIES.includes(countryCode);
export const isOutsideEU = (countryCode: string) => !EU_COUNTRIES.includes(countryCode);
